import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { PopupMessage, PopupState } from './types';

const initialState: PopupState = {
  messages: [],
};

export const popupSlice = createSlice({
  name: 'popup',
  initialState,
  reducers: {
    addMessage: (state, action: PayloadAction<PopupMessage>) => {
      state.messages = [...state.messages, action.payload];
    },
    removeMessage: (state, action: PayloadAction<string>) => {
      state.messages = state.messages.filter(
        (item) => item.id !== action.payload
      );
    },
  },
});

export const { addMessage, removeMessage } = popupSlice.actions;
export const popupReducer = popupSlice.reducer;
